export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {title: '分公司', dataIndex: 'orgName', width: 160, ellipsis: true},
    {title: '外呼服务商', dataIndex: 'brandName', width: 160, ellipsis: true},
    {title: '线路', dataIndex: 'lineName', width: 160, ellipsis: true},
    {title: '最后修改人', dataIndex: 'modifiedByName', width: 160, ellipsis: true},
    {title: '最后修改时间', dataIndex: 'lastUpdatedTime', width: 180, itemType: 'dateTime'},
    {title: '操作', dataIndex: '#', width: 200, fixed: 'right', render: 'actionRender'},
  ],
  search: [
    {
      name: 'brand',
      label: '外呼服务商',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'brandEnum',
      width: 400,
    },
    {
      name: 'orgId',
      label: '分公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      width: 400,
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
